import httpClient from "./httpClient";

const prefix = "/complaints";

export interface Complaint {
  id: number;
  name: string;
  branch: {
    id: number;
    name: string;
  };
  position: {
    id: number;
    name: string;
  };
  partner?: {
    id: number;
    person?: {
      firstName: string;
      lastName: string;
      secondLastName: string;
      curp: string;
    };
    candidate?: {
      branch?: {
        name: string;
      };
      vacancy?: {
        position?: {
          name: string;
        };
      };
    };
  };
  reviewer?: {
    id: number;
    name: string;
    lastName: string;
  };
  comments: string;
  date: string;
  status: string;
  reviewedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateComplaintDto {
  name: string;
  branchId: number;
  positionId: number;
  comments: string;
  date: string;
}

export interface UpdateComplaintDto {
  name?: string;
  branchId?: number;
  positionId?: number;
  comments?: string;
  date?: string;
  reviewerId?: number;
  reviewedAt?: string;
  status?: string;
}

export interface PaginationComplaintsDto {
  limit?: number;
  offset?: number;
  branchId?: number;
  positionId?: number;
  param?: string;
  sort?: string;
  order?: "ASC" | "DESC";
}

export async function getComplaintsList(params?: PaginationComplaintsDto) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value.toString());
      }
    });
  }
  const query = queryParams.toString();
  return (await httpClient.get(`${prefix}?${query}`)).data;
}

export async function getComplaintsStats(): Promise<{ total: number; pendientes: number; revisadas: number; anonimas: number }> {
  return (await httpClient.get(`${prefix}/stats`)).data;
}

export async function getComplaint(id: number) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function createComplaint(data: CreateComplaintDto) {
  return (await httpClient.post(`${prefix}`, data)).data;
}

export async function updateComplaint(id: number, data: UpdateComplaintDto) {
  return (await httpClient.patch(`${prefix}/${id}`, data)).data;
}

export async function deleteComplaint(id: number) {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}
